import React from "react";
import { useNewLayout } from "store/selectors/hooks";
import { NgByline, NgBylineProps } from "./ng-byline";

export interface NgBylinePillProps extends NgBylineProps {
    className?: string;
}

export const NgBylinePill = (props: NgBylinePillProps) => {
    const newLayout = useNewLayout() || props.forceNewStyle;

    if (!newLayout) {
        return (
            <div className={`action-bar-component lg:hidden ${props.className}`}>
                <NgByline {...props} />
            </div>
        );
    }
    return (
        <div className={`inline-block lg:hidden ${props.className}`}>
            <NgByline {...props} />
        </div>
    );
};
